import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core'
import { ShellUpdateService, ShellUpdateMessage, ShellActionMessage } from '../../services/shell-update-service/shell-update.service';
import { AppConfigService } from '../../services/app-config-service/app-config.service';
import { Router, NavigationEnd, ResolveEnd } from '@angular/router';
import { PatientSearchService } from '../../services/patient-search-service/patient-search.service';
import { Patient } from '../../../app/domain/patient';
import { MatTableModule, MatTableDataSource, MatSpinner, MatButton } from '@angular/material'
import { HttpResponse } from 'selenium-webdriver/http';
import { HttpErrorResponse } from '@angular/common/http/src/response';
import { UserSessionService } from '../../services/user-session-service/user-session.service';
import { Subscription } from 'rxjs/Subscription';
import { LoggingService } from '../../services/logging-service/logging.service';
import { AfterViewInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { ElementRef } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Button, IButton } from 'selenium-webdriver';
import { AuthorisationService } from '../../services/authorisation-service/authorisation-service.service';
import { MatSnackBar } from '@angular/material';
import 'rxjs/add/operator/map';
import { Response } from '@angular/http';
import { Observable } from 'rxjs';
////-------------------------------------------------------------------------------------------
// Author:      Martin Unger
// Created:     16/01/2017     
// Description: Allows users to search for patients to add from E3
////-------------------------------------------------------------------------------------------

@Component({
  selector: 'app-intrapartum-search-view',
  templateUrl: './portal-admin-search.component.html',
  styleUrls: ['./portal-admin-search.component.css']
})
export class PortalAdminSearchViewComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('searchBox') vc: ElementRef;
  public foundPatients: Patient[];
  private patientSearchSubscription: Subscription;
  public dataSource: MatTableDataSource<Patient>;
  public displayedColumns = ['HOSPITALNUMBER', 'NHSNUMBER', 'SURNAME', 'FORENAMES', 'DOB', 'AGE', 'VIEWBUTTON', 'BUTTON'];
  public searchQuery: string;
  public searchFilter: string = 'HospitalNumber';
  public searching: boolean;
  public loading: boolean;
  public disableSearchButton: boolean = true;
  public HospitalSelectedColor: string;
  public NhsSelectedColor: string;
  public SurnameSelectedColor: string;

  constructor(private shellUpdateService: ShellUpdateService,
    private appConfigService: AppConfigService, private patientSearchService: PatientSearchService,
    private router: Router, private userSession: UserSessionService, private loggingService: LoggingService,
    private authorisationService: AuthorisationService,
    private breakpointObserver: BreakpointObserver, private snackBar: MatSnackBar) { }

  ngAfterViewInit() {
    setTimeout(() => {
      this.vc.nativeElement.focus();
    });
  }

  ngOnInit() {
    // Make sure the route being accessed is desirable (not user from admin, or admin from user. Redirect if required)
    this.userSession.checkRoute(this.router.url);
    this.shellUpdateService.sendShellUpdateMessage(new ShellUpdateMessage(this.appConfigService.ApplicationName,
      'Patient Search', null, ''));
    this.shellUpdateService.sendShellUpdateActionMessage(new ShellActionMessage(false, false, true, false, true));
    this.HospitalSelectedColor = 'accent';
    this.breakpointObserver.observe([
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait
    ]).subscribe(result => {
      if (result.matches) {
        this.displayedColumns = ['HOSPITALNUMBER', 'SURNAME', 'VIEWBUTTON', 'BUTTON']
      } else {
        this.displayedColumns = ['HOSPITALNUMBER', 'NHSNUMBER', 'SURNAME', 'FORENAMES', 'DOB', 'AGE', 'VIEWBUTTON', 'BUTTON'];
      }
    });
  }

  // Cleans up any subscriptions
  ngOnDestroy() {
    if (this.patientSearchSubscription) {
      this.patientSearchSubscription.unsubscribe();
    }
    this.loggingService.log('Unsubscribed from patientSearchSubscription', this.appConfigService.LogToConsole);
  }

  // Set the patient data and then go to the view
  viewPatient(patient: Patient, event: MouseEvent) {
    this.appConfigService.PatientId = patient.Id;
    this.router.navigate(['app', 'admin', 'patient']);
  }

  // Searches for patients using the E3 Maternity API
  private searchUsingApi() {
    this.loading = true;
    this.loggingService.log('Communicating with API', this.appConfigService.LogToConsole);
    this.patientSearchSubscription = this.patientSearchService.search(this.searchQuery, this.searchFilter).subscribe((response) => {
      this.foundPatients = response.json();
      this.foundPatients.map(patient => this.checkStatus(patient).subscribe(response => {
        this.updatePatientButton(patient, response);
      }));
      this.ShowFoundPatientCount();
      this.bindDataSource();
    }, ((error: HttpErrorResponse) => {
      if (error.status == 401) {
        this.snackBar.open('Sorry, we can\'t do that. Your login has expired.', '', { duration: 5000 });
        this.loggingService.log('Login expired', this.appConfigService.LogToConsole);
        this.disableSearchButton = false;
        this.userSession.logout();
      }
      else if (error.status == 404) {
        this.snackBar.open('Sorry, no matching patients were found.', '', { duration: 5000 });
        this.loggingService.log('No patient search results', this.appConfigService.LogToConsole);
        this.disableSearchButton = false;
        this.showNoPatientsFound();
      }
      else if (error.status == 500) {
        this.snackBar.open('Sorry, we couldn\'t do that for you due to a Server error.', '', { duration: 5000 });
        this.loggingService.log('Patient search - server error', this.appConfigService.LogToConsole);
        this.disableSearchButton = false;
        this.showServerError();
      }
      else if (error.status == 0) {
        this.loading = false;
        this.disableSearchButton = false;
        this.loggingService.log('Patient search - lost internet connection', this.appConfigService.LogToConsole);
        this.snackBar.open('Sorry, we couldn\'t do that for you. You appear to be offline.', '', { duration: 5000 });
      }
    }));
  }

  // Updates the patient button with the correct data depending on the patients authorisation state
  updatePatientButton(patient: Patient, status: number) {
    patient.ViewButtonText = 'View';
    switch (status) {
      case 0:
        patient.ButtonText = 'Not Authorised';
        patient.ButtonAuthorised = false;
        break;
      case 1:
        patient.ButtonText = 'Authorised';
        patient.ButtonAuthorised = true;
        break;
      default:
        break;
    }
  }

  // Will either authorise or deauthorise a patient depending on the patients existing state
  switchStatusOnClick(patient: Patient, event: MouseEvent) {
    switch (patient.ButtonAuthorised) {
      case true:
        this.deauthorise(patient, event);
        break;
      case false:
        this.authorise(patient, event);
        break;
      default:
        break;
    }
  }

  checkStatus(patient: Patient) {
    this.loggingService.log('Checking patient status', this.appConfigService.LogToConsole);
    return this.authorisationService.checkStatus(patient).map(response => response.json()).map(x => x.AuthorisationStatus);
  }

  clearSearch() {
    this.loggingService.log('Clearing search', this.appConfigService.LogToConsole);
    this.searchQuery = null;
    this.clearDataSource();
    this.clearSearchPatientsFound()
    this.disableIfNoSearchString();
  }

  authorise(patient: Patient, event: MouseEvent) {
    patient.ButtonAdding = true;
    this.authorisationService.getPatientEmail(patient).map(response => response.json()).map(e => e.EmailAddress).subscribe(response => {
      this.authorisationService.authorise(patient, response).subscribe(response => {
        patient.ButtonAdding = false;
        patient.ButtonAuthorised = true;
        patient.ButtonText = 'Authorised';
        this.snackBar.open(`Patient ${patient.Surname}, ${patient.Forenames} has been authorised.`, '', { duration: 5000 });

      }, (error: HttpErrorResponse) => {
        patient.ButtonAdding = false;

        // Problems authorising 
        if (error.status == 401) {
          this.snackBar.open('Sorry, we can\'t do that. Your login has expired.', '', { duration: 5000 });
          this.loggingService.log('Login expired', this.appConfigService.LogToConsole);

          this.userSession.logout();
        }
        if (error.status == 403) {
          patient.ButtonAdding = false;
          this.loggingService.log('Authorisation error', this.appConfigService.LogToConsole);
          this.snackBar.open(`Patient ${patient.Surname}, ${patient.Forenames} could not be authorised. Forbidden.`, '', { duration: 5000 });
        }
        if (error.status == 409) {
          this.loggingService.log('Authorisation error - email address already exists', this.appConfigService.LogToConsole);
          this.snackBar.open(`Patient ${patient.Surname}, ${patient.Forenames} could not be authorised. Email address already exists for a different patient.`, '', { duration: 5000 });
        }
        if (error.status == 500) {
          this.loggingService.log('Server error', this.appConfigService.LogToConsole);
          patient.ButtonAdding = false;
          this.snackBar.open(`Patient ${patient.Surname}, ${patient.Forenames} could not be authorised. Server error.`, '', { duration: 5000 });
        }
      });
    }, (error: HttpErrorResponse) => {
      patient.ButtonAdding = false;

      // Problem getting the users email address
      if (error.status == 401) {
        this.loggingService.log('Patient search - login expired', this.appConfigService.LogToConsole);
        this.snackBar.open('Sorry, you have been automatically logged out.', '', { duration: 5000 });
        this.userSession.logout();
      }
      if (error.status == 409) {
        this.loggingService.log('Patient could not be authorised ', this.appConfigService.LogToConsole);
        this.snackBar.open(`Patient ${patient.Surname}, ${patient.Forenames} could not be authorised. Email address already exists for a different patient.`, '', { duration: 5000 });

      }
      if (error.status == 500) {
        this.loggingService.log('Patient search - server error ', this.appConfigService.LogToConsole);
        this.snackBar.open(`Patient ${patient.Surname}, ${patient.Forenames} could not be authorised. Server error.`, '', { duration: 5000 });

      }
      if (error.status == 404) {
        this.snackBar.open(`Patient ${patient.Surname}, ${patient.Forenames} could not be authorised. No email address on file.`, '', { duration: 5000 });
        this.loggingService.log('Patient search - server error - no email address on file ', this.appConfigService.LogToConsole);

      }
      if (error.status == 0) {
        this.loading = false;
        this.loggingService.log('Patient search - offline ', this.appConfigService.LogToConsole);
        this.snackBar.open('Sorry, we couldn\'t do that for you. You appear to be offline.', '', { duration: 5000 });
      }

      patient.ButtonAdding = false;
    });
  }

  deauthorise(patient: Patient, event: MouseEvent) {
    patient.ButtonAdding = true;
    return this.authorisationService.deauthorise(patient).subscribe(response => {
      patient.ButtonAuthorised = false;
      patient.ButtonText = 'Not Authorised';
      patient.ButtonAdding = false;
      this.snackBar.open(`Patient ${patient.Surname}, ${patient.Forenames} has been deauthorised`, '', { duration: 5000 });
    }, (error: HttpErrorResponse) => {
      patient.ButtonAdding = false;
      if (error.status == 401) {
        this.userSession.logout();
      }
      this.snackBar.open(`Patient ${patient.Surname}, ${patient.Forenames} could not be deauthorised`, '', { duration: 5000 });
      patient.ButtonAdding = false;
    });
  }

  // Sets a flag bound to the enabled property of the button to enable / disable it
  disableIfNoSearchString() {
    if (this.searchQuery == null) {
      this.disableSearchButton = true;
      return;
    }

    if (this.searchQuery.trim().length == 0) {
      this.disableSearchButton = true;
      return;
    }

    this.disableSearchButton = false;
  }

  // Searches E3 for a user using the API
  searchForPatients(filter: string) {
    try {

      this.loggingService.log('Search initiated', this.appConfigService.LogToConsole);
      this.searchFilter = filter;

      switch (filter) {
        case 'HospitalNumber':
          this.HospitalSelectedColor = 'accent';
          this.NhsSelectedColor = 'secondary';
          this.SurnameSelectedColor = 'secondary';
          break;
        case 'NhsNumber':
          this.HospitalSelectedColor = 'secondary';
          this.NhsSelectedColor = 'accent';
          this.SurnameSelectedColor = 'secondary';
          break;
        case 'Surname':
          this.HospitalSelectedColor = 'secondary';
          this.NhsSelectedColor = 'secondary';
          this.SurnameSelectedColor = 'accent';
          break;

        default:

          break;
      }

      this.validateSearch();
      this.clearDataSource();
      this.showSearching();
      this.searchUsingApi();

    } catch (error) {
      this.loggingService.log('Search Error: ' + error, this.appConfigService.LogToConsole);
    }
  }

  // Clears the data source ready
  private clearDataSource() {
    if (this.dataSource)
      this.dataSource = null;
  }

  // Validate the search inputs
  private validateSearch() {
    if (this.searchQuery == null)
      throw 'Query string cannot be null';
    if (this.searchQuery.length == 0)
      throw 'Query cannot be empty.';
    if (this.searchFilter == null)
      throw 'Filter string cannot be null';
    if (this.searchFilter.length == 0)
      throw 'Filter cannot be empty.';
  }

  // Shows a user we are searching for the entered patient in the footer
  private showSearching() {
    this.disableSearchButton = true;
    this.loggingService.log('Updating UI - searching', this.appConfigService.LogToConsole);
    this.shellUpdateService.sendShellUpdateMessage(
      new ShellUpdateMessage(this.appConfigService.ApplicationName, 'Patient Search', 'Searching ...', ''));
  }
  // Binds the datasource to our found patients
  private bindDataSource() {
    this.loggingService.log('Rebinding DataSource', this.appConfigService.LogToConsole);
    this.dataSource = new MatTableDataSource<Patient>(this.foundPatients);
  }
  // Shows the number of patients found in the footer
  private ShowFoundPatientCount() {
    this.loading = false;
    this.disableSearchButton = false;
    this.vc.nativeElement.focus();
    this.loggingService.log('Updating UI - showing found Patient counts', this.appConfigService.LogToConsole);
    this.shellUpdateService.sendShellUpdateMessage(
      new ShellUpdateMessage(this.appConfigService.ApplicationName, 'Patient Search', this.foundPatients.length.toString() + ' Patient(s) found', ''));
  }

  // Show the user we have a problem with server commms in the footer
  private showServerError() {
    this.loading = false;
    this.disableSearchButton = false;
    this.vc.nativeElement.focus();
    this.loggingService.log('Updating UI - showing error', this.appConfigService.LogToConsole);
    this.shellUpdateService.sendShellUpdateMessage(
      new ShellUpdateMessage(this.appConfigService.ApplicationName, 'Patient Search', 'Server Error', ''));
  }

  // Show no patients have been found in the footer
  private showNoPatientsFound() {
    this.loading = false;
    this.disableSearchButton = false;
    this.vc.nativeElement.focus();
    this.loggingService.log('Updating UI - showing no Patients found', this.appConfigService.LogToConsole);
    this.shellUpdateService.sendShellUpdateMessage(
      new ShellUpdateMessage(this.appConfigService.ApplicationName, 'Patient Search', 'No Patients Found', ''));
  }

  // Show no patients have been found in the footer
  private clearSearchPatientsFound() {
    this.disableSearchButton = false;
    this.vc.nativeElement.focus();
    this.loggingService.log('Updating UI - showing no Patients found', this.appConfigService.LogToConsole);
    this.shellUpdateService.sendShellUpdateMessage(
      new ShellUpdateMessage(this.appConfigService.ApplicationName, 'Patient Search', '', ''));
  }
}


// WEBPACK FOOTER //
// ./src/app/views/portal-admin-search-view/portal-admin-search.component.ts